import React from 'react';
import Hero from '../components/home/Hero';
import Manifesto from '../components/home/Manifesto';
import WhatWeBuild from '../components/home/WhatWeBuild';
import Products from '../components/home/Products';
import Principles from '../components/home/Principles';

const HomePage: React.FC = () => {
  return (
    <>
      <Hero />
      <Manifesto />
      <WhatWeBuild />
      <Products />
      <Principles />
    </>
  );
};

export default HomePage;
